import http from './http';

interface CreateRequest {
  name: string;
  hp: string;
  requestType: string;
  // businessTypes: Array<string>;
  // customBusinessType: string;
  // companyType: string;
  // companyArea: string;
  // recommendOfficeYn: 'Y' | 'N';
  // companyNameKr: string;
  // companyNameEn: string;
  // capital: number;
  // freeRegistrationYn: 'Y' | 'N';
  // utilities: number;
  // address: string;
}

interface UpdateRequest {
  name: string;
  hp: string;
  requestType: string;
  businessTypes: Array<string>;
  customBusinessType: string;
  companyType: string;
  companyArea: string;
  recommendOfficeYn: 'Y' | 'N';
  companyNameKr: string;
  companyNameEn: string;
  capital: number;
  freeRegistrationYn: 'Y' | 'N';
  taxConsultingYn: 'Y' | 'N';
  utilities: number;
  address: string;
  registrationTax: number;
  feeAndTax: boolean;
  /** 마지막 스텝(최종 제출)이면 true — 서버가 큐 대신 동기로 저장한다. */
  isFinal: boolean;
}

export function createRecord(body: CreateRequest) {
  return http.post('/api/request', body);
}

export function updateRecord(recordId: string, body: UpdateRequest) {
  return http.put(`/api/request/${recordId}`, body);
}
